import React, { Fragment } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import { SITENAMEALIAS } from '../utils/init';
import { Link,withRouter } from 'react-router-dom';
import btcLogo from '../assets/images/currency/BTC.svg'


class Balances extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            pageNo: 1,
            noOfItemsPerPage: 20,
        };

    }


    render() {
        return (
            <Fragment>
         <div className="container">
  <div className="row">
    <div className="col-lg-12">
      <h1>Privacy Policy</h1>
      {/* <h2>Scope and Consent</h2> */}
      <p>
        This policy describes how {localStorage.getItem(SITENAMEALIAS + "_exchange") } and its subsidiaries and
        affiliated companies ( “Hashcash Consultants” “we” or “us”) collect,
        store, use, and protect personal information. This policy aims to ensure
        that {localStorage.getItem(SITENAMEALIAS + "_exchange") } complies with applicable United States (US) federal
        and state regulations, and European Union (EU) data protection laws, and
        ensures that users are provided privacy protection. {localStorage.getItem(SITENAMEALIAS + "_exchange") }
        Services include merchant processing services, products, or any other
        features, technologies, or functionalities (hereinafter: “Services”)
        offered by {localStorage.getItem(SITENAMEALIAS + "_exchange") }.
      </p>
      <p>
        There are three types of users whose personal information we may
        process:
      </p>
      <ul>
        <li>1. Visitors to our website</li>
        <li>2. Merchants that sign up for our Services</li>
        <li>
          3. Shoppers who indirectly interface with {localStorage.getItem(SITENAMEALIAS + "_exchange") } when paying a
          merchant’s invoice that is forwarded by {localStorage.getItem(SITENAMEALIAS + "_exchange") } to merchants
          during checkout (refer to Section III.3 for more details).
        </li>
      </ul>
      <p>
        Users accept this Policy by visiting our website and/or by using our
        Services.
      </p>
      <h3>DATA COLLECTION</h3>
      <p>
        (A) {localStorage.getItem(SITENAMEALIAS + "_exchange") } collects all personal data and information of the User
        including sensitive personal information. Use of the {localStorage.getItem(SITENAMEALIAS + "_exchange") }
        services is contingent on acceptance of the terms contained herein. User
        shall be deemed to have volunteered the data and information collected,
        retained, used, and disseminated by {localStorage.getItem(SITENAMEALIAS + "_exchange") }. Thereafter, upon
        accepting the terms herein and those contained in the Terms of Service
        of {localStorage.getItem(SITENAMEALIAS + "_exchange") }.
      </p>
      <p>
        (B) User hereby consents that when personal data is shared with
        {localStorage.getItem(SITENAMEALIAS + "_exchange") }, User hereby agrees and acknowledges {localStorage.getItem(SITENAMEALIAS + "_exchange") }'s right
        to use or disseminate such data or information including transfer of the
        personal and sensitive personal information of the User from current
        location to external sources including outside US and third parties.
      </p>
      <p>
        (C) {localStorage.getItem(SITENAMEALIAS + "_exchange") } collects and retains data and information of users
        including the following:
      </p>
      <p>{localStorage.getItem(SITENAMEALIAS + "_exchange") } Collects and Retains Data &amp; Information of Users</p>
      <ul>
        <li>
          1. Information provided/shared by the User: {localStorage.getItem(SITENAMEALIAS + "_exchange") } collects any
          and all personal information provided by the User to {localStorage.getItem(SITENAMEALIAS + "_exchange") }.
          This information may include that which is provided by the Users, at
          the time of opening an account and transacting with {localStorage.getItem(SITENAMEALIAS + "_exchange") }
          including the following:
        </li>
        <li>2. Name,</li>
        <li>3. Residential Address,</li>
        <li>4. Registered Mobile Number,</li>
        <li>5. Email Address,</li>
        <li>6. Government-issued ID,</li>
        <li>7. Bank Account Details</li>
        <li>8. Any other information.</li>
        <li>
          9. {localStorage.getItem(SITENAMEALIAS + "_exchange") } may collect, retain, use, or store data or information
          automatically collected from a device or through connections
          associated with such device, including but not limited to the
          following:
        </li>
        <li>
          10. User’s device information including but not limited to IMEI or
          equipment identification number, IMSI or subscriber identification,
          MAC address, Android version, device details, network operator,
          contact list information, Wifi / Data Network connectivity.
        </li>
        <li>
          11. Information generated by the User’s use of the app and the
          website, including cookies and IP addresses,
        </li>
        <li>12. Access to User’s Photo Gallery / Media / Files / Camera,</li>
        <li>
          13. Access to User’s other apps and services including messaging
          through SMS; usage data,
        </li>
        <li>
          14. Geolocation of a User’s device or such or other automatically
          collated data or information of User.
        </li>
      </ul>
      <h3>PURPOSE &amp; USE OF DATA COLLECTED</h3>
      <p>
        (A) {localStorage.getItem(SITENAMEALIAS + "_exchange") } collects, retains, and puts to use the information
        shared by the User, as above, with the consent of and concurrence of the
        User. The data and information collected above are utilized by
        {localStorage.getItem(SITENAMEALIAS + "_exchange") }, to ensure the effective rendering of its {localStorage.getItem(SITENAMEALIAS + "_exchange") }
        Services and to comply with legal requirements.
      </p>
      <p>
        (B) {localStorage.getItem(SITENAMEALIAS + "_exchange") } does not sell the data collected and retained by the
        User.
      </p>
      <p>
        (C) Data collected from the User is put to use by {localStorage.getItem(SITENAMEALIAS + "_exchange") } to
        enhance its services to the User.
      </p>
      <h3>COLLECTION OF DATA: {localStorage.getItem(SITENAMEALIAS + "_exchange") } PRIVACY POLICY</h3>
      <h4>(A) Cookies</h4>
      <ul>
        <li>
          1. {localStorage.getItem(SITENAMEALIAS + "_exchange") } uses cookies on its App and website to collect data
          about Users. Cookies collect User information including App usage,
          visits to the App or website, and other User-generated information.
          Cookies allow Users to navigate from page to page without having to
          re-login each time, count visits, and see which areas. It features of
          the {localStorage.getItem(SITENAMEALIAS + "_exchange") } App and website are popular.
        </li>
        <li>
          2. {localStorage.getItem(SITENAMEALIAS + "_exchange") } may also use the data collected via cookies to tailor
          advertisements to Users and to track the popularity of its website.
          Use of cookies and other technologies may allow {localStorage.getItem(SITENAMEALIAS + "_exchange") } and third
          parties to collect information about User browsing activities over
          time and across different websites following use of {localStorage.getItem(SITENAMEALIAS + "_exchange") }
          services.
        </li>
        <li>
          3. {localStorage.getItem(SITENAMEALIAS + "_exchange") } also collects information that your browser sends
          whenever User visits its site. This information may include
          information such as the device’s Internet Protocol (“IP”) address
          (with replaced last byte), browser type, browser version, the pages of
          {localStorage.getItem(SITENAMEALIAS + "_exchange") } site that the User visits, the time and date of visit,
          the time spent on those pages and other statistics.
        </li>
      </ul>
      <h4>(B) Analytics</h4>
      <ul>
        <li>
          1. {localStorage.getItem(SITENAMEALIAS + "_exchange") } uses third-party analytical tools to collect data
          about User devices and Internet connections. That information includes
          the IP address of User computer and/or Internet service provider, when
          the User accesses its website, the Internet address of websites from
          which User links to the {localStorage.getItem(SITENAMEALIAS + "_exchange") } website, specifications of User
          browser, and User movements and preferences on the {localStorage.getItem(SITENAMEALIAS + "_exchange") }
          website. All of this information is used internally for the purpose of
          understanding how the {localStorage.getItem(SITENAMEALIAS + "_exchange") } website is being used and to
          improve the same.
        </li>
        <li>
          2. {localStorage.getItem(SITENAMEALIAS + "_exchange") } also uses third-party analytical tools to collect data
          about the usage of the {localStorage.getItem(SITENAMEALIAS + "_exchange") } mobile app. The information
          collected identifies the types and timing of actions taken, including
          installation, registration, uploading, and certain types of
          navigation. All of this information is for the internal purposes of
          understanding. How the {localStorage.getItem(SITENAMEALIAS + "_exchange") } mobile app is in used to improve
          the same.
        </li>
      </ul>
      <h4>(C) Action Tags</h4>
      <ul>
        <li>
          1. {localStorage.getItem(SITENAMEALIAS + "_exchange") } uses action tags to identify pages visited and
          interacted with by the User. Action tags may collect and transmit this
          data in a manner that identifies the User. If the User registers with
          the {localStorage.getItem(SITENAMEALIAS + "_exchange") } website. It is in the {localStorage.getItem(SITENAMEALIAS + "_exchange") } website.
          {localStorage.getItem(SITENAMEALIAS + "_exchange") } also uses action tags in emails. Thereafter, to determine
          whether an email has been opened or whether it has been forwarded to a
          third party.
        </li>
        <li>
          2. {localStorage.getItem(SITENAMEALIAS + "_exchange") } also uses action tags in the mobile app which may
          identify the websites visited by the User. Moreover, the manner in
          which the User interacts with them.
        </li>
      </ul>
      <h4>(D) Do Not Track</h4>
      <ul>
        <li>
          1. {localStorage.getItem(SITENAMEALIAS + "_exchange") } currently does not respond to “Do Not Track” signals.
          It operates in this Privacy Policy whether or not a Do Not Track
          signal is received. Moreover, if there is a change in such policy, a
          suitable modification to this Privacy Policy by {localStorage.getItem(SITENAMEALIAS + "_exchange") } listing
          out the mechanism and procedure for the same.
        </li>
      </ul>
      <h3>GRIEVANCE</h3>
      <p>
        User may register their grievance with respect to data collection,
        retention or use to {localStorage.getItem(SITENAMEALIAS + "_exchange") }'s Grievance Officer via the contact
        form at  {localStorage.getItem(SITENAMEALIAS + "_brokerDomain") }
      </p>
      <h3>DATA RETENTION</h3>
      <ul>
        <li>
          (A) {localStorage.getItem(SITENAMEALIAS + "_exchange") } shall retain the User’s information for as long as
          the account is active or as needed to provide services in accordance
          with applicable laws.
        </li>
        <li>
          (B) The retention period may be extended to comply with legal
          obligations, resolve disputes, and enforce agreements for a period of
          ten years after termination of the account or such extended period,
          under applicable laws. {localStorage.getItem(SITENAMEALIAS + "_exchange") } may retain data for such or
          further periods. However, there is no obligation to do so in all
          instances. {localStorage.getItem(SITENAMEALIAS + "_exchange") } shall not be liable or responsible for the
          non-availability of information beyond the termination of the User
          account.
        </li>
        <li>
          (C) The retention period may extend beyond the end of User account,
          but it will be only as long as it is necessary for {localStorage.getItem(SITENAMEALIAS + "_exchange") } to
          have sufficient information to respond to any issues that may arise
          later, including but not limited to retention for the purpose of
          investigations or ongoing prosecutions or in case of Suspicious
          transactions or if {localStorage.getItem(SITENAMEALIAS + "_exchange") } requires the information for its
          records or to support legal proceedings, or if {localStorage.getItem(SITENAMEALIAS + "_exchange") } believes
          in good faith that a law, regulation, rule or guideline requires it.
        </li>
      </ul>
      <h3>DATA DELETION PROCEDURE</h3>
      <ul>
        <li>
          (A) PERSONAL DATA: Retained only as long as necessary to fulfill the
          purposes for which it was collected or as required by law. Once the
          retention period ends, personal data is securely deleted.
        </li>
        <li>
          (B) FINANCIAL DATA: Retained as required by applicable financial and
          tax regulations. Once the retention period ends, financial data is
          securely deleted.
        </li>
        <li>
          (C) OPERATIONAL DATA: Retained for a reasonable period to support
          business operations. Once it is no longer needed, operational data is
          securely deleted.
        </li>
        <li>
          (D) LEGAL/COMPLIANCE DATA: Retained for the duration specified by
          applicable laws or regulations. Once the retention period ends,
          legal/compliance data is securely deleted.
        </li>
        <li>
          (E) Data deletion involves securing and retrieving data from all
          relevant storage locations. The procedures for data deletion include:
        </li>
        <li>
          (a) Identifying data to be deleted based on the data retention
          periods.
        </li>
        <li>
          (b) Verifying the deletion request and obtaining necessary approvals.
        </li>
        <li>
          (c) Using appropriate methods and tools to securely delete data.
        </li>
        <li>
          (d) Documenting the deletion process for audit and compliance
          purposes.
        </li>
        <li>
          (e) Customers may request a complete deletion of their data by using
          the “Delete my data” button in the Settings of the {localStorage.getItem(SITENAMEALIAS + "_exchange") }
          interface. Upon using this feature, the customer’s data goes
          immediately to the deletion queue from where it is automatically and
          permanently deleted at the end of the retention period.
        </li>
      </ul>
      <p>
        <b>Request for Data Deletion</b>
      </p>
      <h3>SHARING OF INFORMATION WITH THIRD PARTIES</h3>
      <p>
        The User agrees and consents to {localStorage.getItem(SITENAMEALIAS + "_exchange") } sharing the following
        anonymized data. Otherwise, give {localStorage.getItem(SITENAMEALIAS + "_exchange") } permission to share with
        third parties the following:
      </p>
      <p>
        (A) For advertising, referral, operations, financial services, and
        technology services (such as hosting providers, identity verification,
        support, payment, and email service providers);
      </p>
      <p>
        (B) If required by applicable law or legal process, or if {localStorage.getItem(SITENAMEALIAS + "_exchange") }
        believes that it is in accordance with applicable law or legal process;
      </p>
      <p>
        (C) To protect the rights, property and safety of {localStorage.getItem(SITENAMEALIAS + "_exchange") }, its
        users and the public, including, including but not limited to usage in
        court proceedings, or to detect or prevent criminal activity, fraud,
        material misrepresentation, or to establish its rights or defend against
        legal claims; or
      </p>
      <p>
        (D) In connection with selling, merging, transferring, or reorganizing
        all or parts of the {localStorage.getItem(SITENAMEALIAS + "_exchange") } business.
      </p>
      <h3>{localStorage.getItem(SITENAMEALIAS + "_exchange") } PRIVACY POLICY: REASONABLE SECURITY PRACTICES</h3>
      <p>
        (A) Protection of the User’s personal information is of utmost
        importance to {localStorage.getItem(SITENAMEALIAS + "_exchange") } and it takes all reasonable steps to secure
        data and information pertaining to its Users, including those prescribed
        under all applicable laws
      </p>
      <p>
        (B) {localStorage.getItem(SITENAMEALIAS + "_exchange") } takes appropriate legal, administrative, physical, and
        electronic measures designed to protect the information. Moreover, users
        share with {localStorage.getItem(SITENAMEALIAS + "_exchange") } from accidental or unlawful destruction,
        accidental loss or unauthorized access, use, modification, interference,
        or disclosure.
      </p>
      <p>
        (C) {localStorage.getItem(SITENAMEALIAS + "_exchange") } however does not extend any warranties with respect to
        the security or safety of data and information transmitted through
        digital platforms or online, both of which are susceptible to malicious
        attacks.
      </p>
      <h3>MODIFICATIONS</h3>
      <p>
        Admin conducts periodic reviews and revisions. User will be notified
        through an update of the App. Thereafter, the new draft available on the
        {localStorage.getItem(SITENAMEALIAS + "_exchange") } Website and will reflect the modified date of the terms.
        User must periodically visit the website and review terms and any
        changes thereto. Continued use of the {localStorage.getItem(SITENAMEALIAS + "_exchange") } Services constitutes
        agreement of User to the terms contained herein and any amendments
        thereto.
      </p>
      <h3>MISCELLANEOUS</h3>
      <p>
        All other provisions of the {localStorage.getItem(SITENAMEALIAS + "_exchange") } privacy policy begin into this
        policy and shall form part hereof. This includes Governing Laws and
        jurisdiction, notices, severability, assignment and such or other
        provisions
      </p>
    </div>
  </div>
</div>
            </Fragment>

        )
    }

    componentDidMount() {


    }

}



export default withRouter(Balances);

